<script lang="ts">
  import {
    getProductGridListStyle,
    styleToString,
  } from "@shared/common/node/style";
  import type {
    IProductGridListNode,
    PartialNode,
  } from "@shared/common/node/type";
  import type { IProductListData } from "@shared/common/types/data-source";
  import { onMount } from "svelte";
  import { getStore } from "../../context";
  import ProductItem from "./product-item.svelte";

  const { dataMap } = getStore();

  export let node: PartialNode<IProductGridListNode>;

  $: productsFromDataMap = node.dataAlias
    ? ($dataMap[node.dataAlias] as IProductListData | undefined)?.data
    : undefined;

  let nodeRef: HTMLDivElement | null;

  function calculateNumOfCols() {
    if (!nodeRef || node.cellWidth?.type !== "MIN") {
      return;
    }

    const computedStyle = getComputedStyle(nodeRef);
    const nodeEleContentWidth =
      nodeRef.getBoundingClientRect().width -
      parseFloat(computedStyle.paddingLeft) -
      parseFloat(computedStyle.paddingRight);

    adjustedNumOfCols = Math.min(
      node?.col ?? 5,
      Math.floor(nodeEleContentWidth / node.cellWidth.value)
    );
  }

  let adjustedNumOfCols: number = node?.col ?? 5;

  onMount(() => {
    if (!nodeRef || node.cellWidth?.type !== "MIN") {
      return;
    }

    const observer = new ResizeObserver(calculateNumOfCols);
    observer.observe(nodeRef);

    return () => {
      observer.disconnect();
    };
  });

  const row =
    typeof node.row === "number" ? (node.row <= 0 ? Infinity : node.row) : 2;

  $: productsData = (
    productsFromDataMap?.items ||
    node.initialData ||
    []
  ).slice(0, adjustedNumOfCols * row);
</script>

<div
  style={`${styleToString(
    getProductGridListStyle({ ...node, col: adjustedNumOfCols })
  )} z-index: 0;`}
  class="aspect-ratio"
  bind:this={nodeRef}
>
  {#if productsData && productsData.length > 0}
    <div class="product-grid-list-container">
      {#each productsData as product}
        <ProductItem {product} {node} />
      {/each}
    </div>
  {:else}
    <div>
      <p>상품이 없습니다.</p>
    </div>
  {/if}
</div>

<style>
  .aspect-ratio::before {
    content: "";
    padding-top: var(--cb-before-padding-top);
    float: left;
  }

  .aspect-ratio::after {
    clear: left;
    content: " ";
    display: table;
  }

  .product-grid-list-container {
    display: grid;
    justify-items: center;
    grid-template-columns: repeat(var(--cb-product-grid-list-column), 1fr);
    /* 기본값 24px 16px */
    gap: calc(var(--cb-product-grid-list-gap) * 1.5)
      var(--cb-product-grid-list-gap);
    padding: var(--cb-product-grid-list-gap) 0;
  }
</style>
